let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c45pb")).then(() => parcelRequire('y1Wnl'));